<template>
  <div>
    <div>
      <p>Заявка: <strong>{{ data.order.id }}</strong></p>
      <p>Клиент: <strong>{{ data.order.client_name || 'Не указан' }}</strong></p>
      <p>Телефоны:</p>
      <div class="flex" v-for="phone in data.order.order_phones">
        <span class="mr-2">{{ mixinPrintPhone(phone.phone.phone) }}</span>
        <MakeCall
          :order="data.order"
          :phone="{phone: phone.phone.phone, valid: true}"
        />
      </div>
      <p>Адрес: {{ data.order.address }}</p>
      <hr>
      <div class="row">
        <div class="col-md-6">
          <p v-for="drug in data.order.details">
            {{ drug.new_drug.title }} * <strong>{{ drug.qty }}</strong> * <strong>{{ drug.price }}</strong>
          </p>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="">Дата планируемой доставки</label>
            <OrderDateSelect
              ref="selectedDate"
              :disabled="true"
              :onSelect="date => (data.order.delivery_date = date)"
              :selectedDate="data.order.delivery_date"
            />
          </div>
        </div>
      </div>
      <div v-if="dateChanged()" class="form-group">
        <label for="">Комментарий к изменению даты доставки</label>
        <input type="text" class="form-control" placeholder="Причина смены даты доставки" v-model="comment">
      </div>
    </div>
  </div>
</template>

<script>

import MakeCall from '@/components/orders/telephony/MakeCall';
import OrderDateSelect from '@/views/reports/components/OrderDateSelect';
import api from '@/api';
import store from "@/store";
import moment from "moment";
import {updateDynamicStoreData} from "@/eventsBus";

export default {
  props: ['data'],
  components: {
    MakeCall,
    OrderDateSelect,
  },
  data() {
    return {
      comment: null,
      saveDisabled: true,
      savedDeliveryDate: null,
    }
  },
  created() {
    this.savedDeliveryDate = this.data.order.delivery_date;
  },
  methods: {
    dateChanged() {
      return moment(this.data.order.delivery_date).format('DD.MM.YYYY') !== moment(this.savedDeliveryDate).format('DD.MM.YYYY')
    },
    async saveData(e = null, reject = false) {
      if (!this.dateChanged()) {
        return {success: false, message: 'дата доставки не изменена'};
      }
      if (!this.comment) {
        return {success: false, message: 'отсутствуем комментарий'};
      }

      const sendData = {
        orderId: this.data.order.id,
        fields: {
          delivery_date: moment(this.$refs.selectedDate.date).format("YYYY-MM-DD"),
          comment: this.comment
        },
      };

      let {data} = await api.post("/orders/updateOrderByField", sendData)
      return data;
    }
  }
}
</script>
